import { render, staticRenderFns } from "./ShowCommentsCards.vue?vue&type=template&id=d15d23ce&scoped=true"
import script from "./ShowCommentsCards.vue?vue&type=script&lang=ts"
export * from "./ShowCommentsCards.vue?vue&type=script&lang=ts"
import style0 from "./ShowCommentsCards.vue?vue&type=style&index=0&id=d15d23ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15d23ce",
  null
  
)

export default component.exports